export default __webpack_public_path__ + "static/media/live8.449fd025.jpeg";